import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import './Styles/main.scss';
import './Styles/tailwind.css';
import App from './App.js';
import './i18nextInit.js';
import * as serviceWorker from './serviceWorker.js';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { configureAxios } from './utils/configureAxios.js';
import { queryClient } from './lib/store.js';
import AnalyticsLoaders from './components/Analytics/AnalyticsLoaders.jsx';

configureAxios();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AnalyticsLoaders />
      <App />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);

// ReactDOM.createRoot(
//     <>
//         <App />
//     </>,
//     document.getElementById('root')
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
